import React from 'react'
import dayjs from 'dayjs';
////////////////////////////////////////////////////////////

import _20190501_koCopyright from './20190501/ko/copyright'
import _20190501_koPrivacy from './20190501/ko/privacy'
import _20190501_koTos from './20190501/ko/tos'

import _20190501_enCopyright from './20190501/en/copyright'
import _20190501_enPrivacy from './20190501/en/privacy'
import _20190501_enTos from './20190501/en/tos'

import _20190501_jpCopyright from './20190501/jp/copyright'
import _20190501_jpPrivacy from './20190501/jp/privacy'
import _20190501_jpTos from './20190501/jp/tos'

////////////////////////////////////////////////////////////

import _20210501_koCopyright from './20210501/ko/copyright'
import _20210501_koPrivacy from './20210501/ko/privacy'
import _20210501_koTos from './20210501/ko/tos';


import _20210501_enCopyright from './20210501/en/copyright'
import _20210501_enPrivacy from './20210501/en/privacy'
import _20210501_enTos from './20210501/en/tos'

import _20210501_jpCopyright from './20210501/jp/copyright'
import _20210501_jpPrivacy from './20210501/jp/privacy'
import _20210501_jpTos from './20210501/jp/tos'

import _20210501_thCopyright from './20210501/th/copyright'
import _20210501_thPrivacy from './20210501/th/privacy'
import _20210501_thTos from './20210501/th/tos'

import _20210501_viCopyright from './20210501/vi/copyright'
import _20210501_viPrivacy from './20210501/vi/privacy'
import _20210501_viTos from './20210501/vi/tos'

import _20210501_idCopyright from './20210501/id/copyright'
import _20210501_idPrivacy from './20210501/id/privacy'
import _20210501_idTos from './20210501/id/tos'

////////////////////////////////////////////////////////////

import _20230101_koPrivacy from './20230101/ko/privacy'
import _20230101_koTos from './20230101/ko/tos'
import _20230101_koPrivacyTable from "./20230101/ko/tableData";

import _20230101_enTos from './20230101/en/tos'

import _20230101_jpTos from './20230101/jp/tos'

import _20230101_thTos from './20230101/th/tos'

import _20230101_viTos from './20230101/vi/tos'

import _20230101_idTos from './20230101/id/tos'

////////////////////////////////////////////////////////////

import _20241101_koTos from './20241101/ko/tos'
import _20241101_koAi from './20241101/ko/ai'

import _20241101_enTos from './20241101/en/tos'
import _20241101_enAi from './20241101/en/ai'

import _20241101_jpTos from './20241101/jp/tos'
import _20241101_jpAi from './20241101/jp/ai'

////////////////////////////////////////////////////////////

import _cafe24_koCopyright from './cafe24/ko/copyright'
import _cafe24_koPrivacy from './cafe24/ko/privacy'
import _cafe24_koTos from './cafe24/ko/tos'

////////////////////////////////////////////////////////////

const parseStrToJSON = str => {
    const arr = str.split('\n')

    const json = {
        header: null,
        headerSub: null,

        body: [],

        footer: null,
        footerSub: null,
		footerSub2: null
    }

    let index = 0
    let currentObj
    while (index < arr.length) {
        const s = arr[index]

        if (s.startsWith('{BODY_TITLE}')) {
            currentObj = {
                title: s.replace('{BODY_TITLE}', ''),
                body: []
            }
            json.body.push(currentObj)
        }
        else if (s.startsWith('{HEADER}')) json.header = s.replace('{HEADER}', '')
        else if (s.startsWith('{HEADER_SUB}')) json.headerSub = s.replace('{HEADER_SUB}', '')
        else if (s.startsWith('{FOOTER}')) json.footer = s.replace('{FOOTER}', '')
        else if (s.startsWith('{FOOTER_SUB}')) json.footerSub = s.replace('{FOOTER_SUB}', '')
        else if (s.startsWith('{FOOTER_SUB_2}')) json.footerSub2 = s.replace('{FOOTER_SUB_2}', '')
        else if (s.startsWith('{ADD_LINE}')) currentObj.body.push(<br />)
        else if (s !== '') currentObj.body.push(s)

        index++
    }

    return json
}

export const copyright = {
    '2019-05-01': {
        ko: parseStrToJSON(_20190501_koCopyright),
        en: parseStrToJSON(_20190501_enCopyright),
        jp: parseStrToJSON(_20190501_jpCopyright)
    },
    '2021-05-01': {
        ko: parseStrToJSON(_20210501_koCopyright),
        en: parseStrToJSON(_20210501_enCopyright),
        jp: parseStrToJSON(_20210501_jpCopyright),
    },
    'cafe24': {
        ko: parseStrToJSON(_cafe24_koCopyright),
    }
}

export const privacy = {
    '2019-05-01': {
        ko: parseStrToJSON(_20190501_koPrivacy),
        en: parseStrToJSON(_20190501_enPrivacy),
        jp: parseStrToJSON(_20190501_jpPrivacy)
    },
    '2021-05-01': {
        ko: parseStrToJSON(_20210501_koPrivacy),
        en: parseStrToJSON(_20210501_enPrivacy),
        jp: parseStrToJSON(_20210501_jpPrivacy),
    },
    '2023-01-01': {
        ko: parseStrToJSON(_20230101_koPrivacy),
    },
    'cafe24': {
        ko: parseStrToJSON(_cafe24_koPrivacy),
    }
}

export const koPrivacyTable = {
    required: _20230101_koPrivacyTable.privacy,
    optional: _20230101_koPrivacyTable.privacyOptional
}


export const tos = {
    '2019-05-01': {
        ko: parseStrToJSON(_20190501_koTos),
        en: parseStrToJSON(_20190501_enTos),
        jp: parseStrToJSON(_20190501_jpTos)
    },
    '2021-05-01': {
        ko: parseStrToJSON(_20210501_koTos),
        en: parseStrToJSON(_20210501_enTos),
        jp: parseStrToJSON(_20210501_jpTos),
    },
    '2023-01-01': {
        ko: parseStrToJSON(_20230101_koTos),
        en: parseStrToJSON(_20230101_enTos),
        jp: parseStrToJSON(_20230101_jpTos),
    },
    '2024-11-18': {
        ko: parseStrToJSON(_20241101_koTos),
        jp: parseStrToJSON(_20241101_jpTos),
        en: parseStrToJSON(_20241101_enTos),
    },
    'cafe24': {
        ko: parseStrToJSON(_cafe24_koTos),
    }
}

export const ai = {
    '2024-11-01': {
        ko: parseStrToJSON(_20241101_koAi),
        jp: parseStrToJSON(_20241101_jpAi),
        en: parseStrToJSON(_20241101_enAi),
    },
    'cafe24': {
        ko: parseStrToJSON(_20241101_koAi),
    }
}

function GetContent(_map, _date, _lang) {
    let date = _date
    let lang = _lang

    const keys = Object.keys(_map)
    keys.sort((a, b) => a > b ? 1 : a < b ? -1 : 0)
    if (!_map[date]) date = keys[keys.length - 1]
    if (!_map[date][lang]) lang = 'en'

    return _map[date][lang]
}

export const GetCopyright = (lang, date) => GetContent(copyright, date, lang)
export const GetPrivacy = (lang, date) => GetContent(privacy, date, lang)
export const GetTos = (lang, date) => GetContent(tos, date, lang)
export const GetAi = (lang, date) => GetContent(ai, date, lang)

export const GetDateKeys = (type) => {
    let dateKeys;
    switch (type) {
        case "copyright":
            dateKeys = Object.keys(copyright);
            break;
        case "privacy":
			dateKeys = Object.keys(privacy);
            break;
        case "tos":
            dateKeys = Object.keys(tos);
            break;
        case "ai":
            dateKeys = Object.keys(ai);
            break;
        default:
            return [];
    }
	return dateKeys.filter(v => v !== 'cafe24').sort((a, b) => new Date(b) - new Date(a));
};

export const GetLabels = (type, lang) => {
	const dateKeys = GetDateKeys(type);
    const labelMap = {
        ko: ["{NUMBER}차 {BODY} ({DATE})", "최초 {BODY} ({DATE})"],
        en: ["{NUMBER} {BODY} ({DATE})", "1st {BODY} ({DATE})"],
        jp: ["{NUMBER}次 {BODY} ({DATE})", "最初の {BODY} ({DATE})"],
    };

    if (!labelMap[lang]) lang = "en";

    const ordinal = (number) => {
        const ordinals = ["th", "st", "nd", "rd"];
        const remainder = number % 100;
        return (
            ordinals[(remainder - 20) % 10] ||
            ordinals[remainder] ||
            ordinals[0]
        );
    };

	const formatDate = (date, lang) => {
        switch (lang) {
            case 'ko':
                return dayjs(date).format('YYYY년 M월 D일');
            case 'en':
                return dayjs(date).format('MMMM D, YYYY');
            case 'jp':
                return dayjs(date).format('YYYY年M月D日');
            default:
                return date;
        }
    };

    return dateKeys.map((date, idx) => {
        const firstNum = dateKeys.length - 1;
		const formattedDate = formatDate(date, lang);
        const bodyLabel =
            idx === firstNum
                ? labelMap[lang][1]
                : labelMap[lang][0].replace(
                      "{NUMBER}",
                      `${firstNum - idx + 1}${
                          lang === "en" || lang == "id"
                              ? ordinal(firstNum - idx + 1)
                              : ""
                      }`
                  );
        return bodyLabel.replace("{DATE}", formattedDate);
    });
};

export const dateObj = {
    first: '2019-05-01',
    second: '2021-05-01',
    third: '2023-01-01',
	fourth: '2024-11-01',
	fifth: '2024-11-18'
}